import React, { useContext } from "react";
import { Box, Typography, IconButton, Avatar, Menu, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../Context/AuthContext";
import UniversalNotificationBell from "../Common/UniversalNotificationBell";

function formatRole(role) {
  if (!role) return "";
  switch (role) {
    case "superadmin":
      return "Super Admin";
    case "manager":
      return "Manager";
    case "admin":
      return "Admin";
    case "hr":
      return "HR";
    case "accountant":
      return "Accountant";
    default:
      return role.charAt(0).toUpperCase() + role.slice(1);
  }
}

function Navbar() {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleLogout = () => {
    if (typeof logout === "function") logout();
    navigate("/");
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr",
        alignItems: "center",
        px: 3,
        py: 1.5,
        background: "#003e6d",
        color: "#fff",
        borderRadius: 0,
      }}
    >
      
      {/* LEFT (empty for balance OR future use) */}
      <Box />

      {/* CENTER TITLE */}
      <Typography
        variant="h6"
        sx={{
          textAlign: "center",
          fontWeight: 700,
          fontSize: "20px",
          color: "#fff"
        }}
      >
        Premier Admin
      </Typography>

      {/* RIGHT SIDE */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 2 }}>
        
        {/* 🔔 Notification */}
        <UniversalNotificationBell />

        {/* 👤 User */}
        <IconButton onClick={handleMenuOpen}>
          <Avatar sx={{ bgcolor: "#6b7280" }}>
            {user?.name?.charAt(0) || "A"}
          </Avatar>
        </IconButton>

        {/* Role Text */}
        <Typography sx={{ fontWeight: 500,color:"#fff"}}>
          {formatRole(user?.role)}
        </Typography>
        <Avatar sx={{ bgcolor: "#fff", color: "#7c5d3a", fontWeight: "bold" }}></Avatar>

        {/* Dropdown */}
        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
          <MenuItem disabled>{user?.name || user?.email}</MenuItem>
          <MenuItem onClick={handleLogout} sx={{ color: "red" }}>
            Logout
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  );
}

export default Navbar;
